var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('br'),_c('div',{attrs:{"id":"vousetes"}},[_vm._v("Vous êtes :")]),_c('div',[_c('k-field',{attrs:{"nolabel":""}},[_c('CEnumFieldView',{attrs:{"id":"type1","field":"Employeur.type","name":"typeEmployeur","radio":"","value":"CHR","excludes":['EXCEP'],"display-names":{
          CHR: 'Un café, un hôtel ou un restaurant',
          COLLECTIVITE: 'Une collectivité territoriale',
          AUTRE: 'Un autre employeur occasionnel'
          }},model:{value:(_vm.type),callback:function ($$v) {_vm.type=$$v},expression:"type"}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }